export const PROJECT_PLAN_START = 'project-plan/project-plan-start';
export const PROJECT_PLAN_START_SUCCESS = 'project-plan/project-plan-success';
export const PROJECT_PLAN_START_ERROR = 'project-plan/project-plan-error';
export const PROJECT_PLAN_SELECT_RESULTS = 'project-pla/select-results';
